export const WIRE_FEE = 0;
